var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"application-alert mb-4",class:_vm.$vuetify.theme.dark ? undefined : 'grey lighten-3',attrs:{"type":_vm.value,"border":"left","colored-border":"","value":""}},[_c('base-markdown',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }